export default __webpack_public_path__ + "static/media/smartb_logo.1ef4c658.svg";